import { ActivatedRouteSnapshot, CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { BrandStrategyComponent } from './brand-strategy.component';

export const BrandStratGuardNavAway: CanDeactivateFn<BrandStrategyComponent> = 
  (component: BrandStrategyComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
    return component.checkNavGuard(nextState.url);
  };
